const CircleHalfDottedClock = (
    <g>
        <path d="m12.249 12c-.146 0-.296-.043-.426-.133l-3.25-2.25c-.202-.14-.323-.371-.323-.617v-4.25c0-.414.336-.75.75-.75s.75.336.75.75v3.857l2.927 2.026c.341.236.426.703.189 1.043-.146.21-.379.323-.617.323z" />
        <path d="m9 17c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c3.584 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c4.411 0 8 3.589 8 8s-3.589 8-8 8z" />
        <circle cx="3.873" cy="14.127" r=".75" />
        <circle cx="1.75" cy="9" r=".75" />
        <circle cx="3.873" cy="3.873" r=".75" />
        <circle cx="6.226" cy="15.698" r=".75" />
        <circle cx="2.302" cy="11.774" r=".75" />
        <circle cx="2.302" cy="6.226" r=".75" />
        <circle cx="6.226" cy="2.302" r=".75" />
    </g>
);

export { CircleHalfDottedClock };
